<template>
  <sContainer imgBg>
    <el-button @click="back" class="back-button">{{
      $t("B2C.back")
    }}</el-button>
    <div class="logo-jumbotron">
      <div
        v-if="customerCheckInfo && customerCheckInfo.length > 0"
        class="errorBox"
      >
        <div class="errorBoxTitle">{{ $t("certification.authFail") }}</div>
        <el-tag
          type="danger"
          v-for="(item, index) in customerCheckInfo"
          :key="index"
        >
          {{ index + 1 }}. {{ item.Error }}
        </el-tag>
      </div>
      <div class="decorate left top"></div>
      <div class="decorate left bottom"></div>
      <div class="decorate right top"></div>
      <div class="decorate right bottom"></div>
      <div class="box login">
        <img src="@/assets/img/logo.png" class="logo" />
        <img src="@/assets/img/descript.png" class="descript" />
      </div>
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="400px"
    >
      <div class="content-box">
        <div class="form-title">{{ $t("certification.title2") }}</div>
        <el-form-item prop="businessLicence" label-width="0">
          <template v-slot:error="{ error }">
            <p class="msg-error">{{ error }}</p>
          </template>
          <div class="license">
            <!-- 示例 -->
            <div class="case">
              <img src="@/assets/img/img_example_1.png" class="casephoto" alt />
              <p>{{ $t("certification.sample") }}</p>
            </div>
            <!-- 上传 -->
            <div class="upload">
              <img
                src="@/assets/img/img_upload_1.png"
                ref="businessLicencePreview"
              />
              <p @click="uploadFile('businessLicence')">
                {{ $t("certification.upload") }}
              </p>
              <input
                type="file"
                accept="image/jpeg, image/jpg, image/png"
                ref="businessLicence"
                :style="{ display: 'none' }"
                @change="fileChanged($event, 'businessLicence')"
              />
            </div>
          </div>
          <!-- 说明文字 -->
          <div class="shuoming">
            <span class="label">{{ $t("certification.subTitle2") }}</span>
            <br />{{ $t("certification.text3") }} <br />{{
              $t("certification.text4")
            }}
          </div>
        </el-form-item>
      </div>
      <!-- 信息开始 -->
      <div class="registerMessage">
        <el-form-item :label="$t('certification.label1')" prop="creditCode">
          <el-input
            v-model="ruleForm.creditCode"
            :placeholder="$t('B2B.input') + ' ' + $t('certification.label1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('certification.label2')" prop="companyName">
          <el-input
            v-model="ruleForm.companyName"
            :placeholder="$t('B2B.input') + ' ' + $t('certification.label2')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('certification.label3')"
          prop="operatingPeriod"
        >
          <el-col :span="16">
            <el-date-picker
              type="date"
              :placeholder="$t('certification.selectDate')"
              v-model="ruleForm.operatingPeriod"
              value-format="yyyy-MM-dd"
              :style="{ width: '100%' }"
              :disabled="operatingPeriodDisabled"
            ></el-date-picker>
          </el-col>
          <el-col :span="1" :offset="1">
            <el-checkbox v-model="ruleForm.isLongOperatingPeriod">{{
              $t("certification.longTime")
            }}</el-checkbox>
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('certification.area')" prop="selectedlocal">
          <el-cascader
            v-model="ruleForm.selectedlocal"
            :options="locationOptions"
            :style="{ width: '100%' }"
            @active-item-change="localActiveItemChangHandle"
            @change="localChangeHandle"
            :placeholder="$t('B2B.select')"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          :label="$t('certification.detailAddress')"
          prop="detailAddress"
        >
          <el-input
            type="textarea"
            v-model="ruleForm.detailAddress"
            :placeholder="$t('certification.detailAddressText')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('certification.lPerson')"
          prop="legalPersonName"
        >
          <el-input
            v-model="ruleForm.legalPersonName"
            :placeholder="$t('B2C.input') + ' ' + $t('certification.lPerson')"
          ></el-input>
        </el-form-item>
      </div>
      <!-- 信息结束 -->
      <!-- 法人身份证开始 -->
      <div class="Id_card">
        <div class="card_title">
          <p>*</p>
          <h4 style="color:#333;">{{ $t("certification.lPersonID") }}</h4>
        </div>
        <el-form-item
          :label="$t('certification.IdNumber')"
          prop="IdentityNumber"
          label-width="250px"
          style="width: 80%;"
        >
          <el-input
            v-model="ruleForm.IdentityNumber"
            :placeholder="$t('B2C.input') + ' ' + $t('certification.IdNumber')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="IDCard1" label-width="0">
          <template v-slot:error="{ error }">
            <p class="msg-error">{{ error }}</p>
          </template>
          <div class="card_content">
            <div class="case">
              <img src="@/assets/img/img_example_2.png" class="casephoto" alt />
              <p>{{ $t("certification.sampleFront") }}</p>
            </div>
            <!-- 上传 -->
            <div class="upload">
              <img src="@/assets/img/img_upload_2.png" ref="IDCard1Preview" />
              <p @click="uploadFile('IDCard1')">
                {{ $t("certification.upload") }}
              </p>
              <input
                type="file"
                accept="image/jpeg, image/jpg, image/png"
                ref="IDCard1"
                :style="{ display: 'none' }"
                @change="fileChanged($event, 'IDCard1')"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="IDCard2" label-width="0">
          <template v-slot:error="{ error }">
            <p class="msg-error">{{ error }}</p>
          </template>
          <div class="card_content">
            <div class="case">
              <img src="@/assets/img/img_example_3.png" class="casephoto" alt />
              <p>{{ $t("certification.sampleBack") }}</p>
            </div>
            <!-- 上传 -->
            <div class="upload">
              <img src="@/assets/img/img_upload_3.png" ref="IDCard2Preview" />
              <p @click="uploadFile('IDCard2')">
                {{ $t("certification.upload") }}
              </p>
              <input
                type="file"
                accept="image/jpeg, image/jpg, image/png"
                ref="IDCard2"
                :style="{ display: 'none' }"
                @change="fileChanged($event, 'IDCard2')"
              />
            </div>
          </div>
        </el-form-item>
        <div class="card_content_text">
          <span class="ratepaying"
            >Vancheen&nbsp;{{ $t("certification.note") }}</span
          >
        </div>
      </div>
      <!-- 法人身份证结束 -->
      <!-- 企业银行信息开-->
      <div class="enterprise_bank">
        <h3 class="enterprise_bank_title">
          {{ $t("certification.bankTitle") }}
        </h3>
        <div class="enterprise_bank_content">
          <el-form-item
            :label="$t('certification.bankName')"
            prop="cBankName"
            :label-width="bankLabelWidth"
          >
            <el-input
              v-model="ruleForm.cBankName"
              :placeholder="
                $t('B2C.input') + ' ' + $t('certification.bankName')
              "
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('certification.bankAccountName')"
            prop="cBankAccountName"
            :label-width="bankLabelWidth"
          >
            <el-input
              v-model="ruleForm.cBankAccountName"
              :placeholder="
                $t('B2C.input') + ' ' + $t('certification.bankAccountName')
              "
            ></el-input>
          </el-form-item>
          <el-form-item :label-width="bankLabelWidth">
            <span style="color:#f00;"
              >*&nbsp;&nbsp;&nbsp;{{ $t("certification.bankNote") }}</span
            >
          </el-form-item>
          <el-form-item
            :label="$t('certification.bankCardNumber')"
            prop="cBankCardNumber"
            :label-width="bankLabelWidth"
          >
            <el-input
              v-model="ruleForm.cBankCardNumber"
              :placeholder="
                $t('B2C.input') + ' ' + $t('certification.bankCardNumber')
              "
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('certification.bankAddress')"
            prop="cBankAddress"
            :label-width="bankLabelWidth"
          >
            <el-input
              type="textarea"
              v-model="ruleForm.cBankAddress"
              :placeholder="
                $t('B2C.input') + ' ' + $t('certification.bankAddress')
              "
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <!-- 企业银行信息结束 -->
      <!-- 法人银行信息开始 -->
      <div class="enterprise_bank">
        <h3 class="enterprise_bank_title">
          {{ $t("certification.legalTitle") }}
        </h3>
        <div class="enterprise_bank_content">
          <el-form-item
            :label="$t('certification.bankName')"
            prop="lBankName"
            :label-width="bankLabelWidth"
          >
            <el-input
              v-model="ruleForm.lBankName"
              :placeholder="
                $t('B2C.input') + ' ' + $t('certification.bankName')
              "
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('certification.bankAccountName')"
            prop="lBankAccountName"
            :label-width="bankLabelWidth"
          >
            <el-input
              v-model="ruleForm.lBankAccountName"
              :placeholder="
                $t('B2C.input') + ' ' + $t('certification.bankAccountName')
              "
            ></el-input>
          </el-form-item>
          <el-form-item :label-width="bankLabelWidth">
            <span style="color:#f00;"
              >*&nbsp;&nbsp;&nbsp;{{ $t("certification.bankNote") }}</span
            >
          </el-form-item>
          <el-form-item
            :label="$t('certification.bankCardNumber')"
            prop="lBankCardNumber"
            :label-width="bankLabelWidth"
          >
            <el-input
              v-model="ruleForm.lBankCardNumber"
              :placeholder="
                $t('B2C.input') + ' ' + $t('certification.bankCardNumber')
              "
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('certification.bankAddress')"
            prop="lBankAddress"
            :label-width="bankLabelWidth"
          >
            <el-input
              type="textarea"
              v-model="ruleForm.lBankAddress"
              :placeholder="
                $t('B2C.input') + ' ' + $t('certification.bankAddress')
              "
            ></el-input>
          </el-form-item>
          <el-form-item :label-width="bankLabelWidth">
            <el-button type="primary" class="submit-btn" @click="submitHandle"
              >{{ $t("B2C.submit") }}</el-button
            >
            <div class="dialog" v-if="show">
              <div class="content">
                <img
                  src="@/assets/img/icon_close.png"
                  class="close"
                  @click="closeAction"
                />
                <img src="@/assets/img/img_text_1.png" class="text" alt />
              </div>
            </div>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <!-- 法人银行信息结束-->
  </sContainer>
</template>
<script>
import { mapMutations, mapActions, mapState } from "vuex";
import { SET_AUTH } from "@/store/mutation-types";
export default {
  props: {
    type: {
      type: String,
      required: true,
      default: "individual",
      validator: value => {
        return ["individual", "business"].indexOf(value) !== -1;
      }
    }
  },
  data() {
    return {
      ruleForm: {
        businessLicence: "", // 营业执照
        creditCode: "", // 社会信用代码
        companyName: "", // 公司名
        operatingPeriod: "", // 经营期限
        isLongOperatingPeriod: false, // 是否长期经营
        selectedlocal: [], // 地区选择
        detailAddress: "", // 详细地址
        legalPersonName: "", // 法人名称
        IDCard1: "", // 身份证正面
        IDCard2: "", // 身份证反面
        IdentityNumber: "", //身份证号码
        cBankName: "", // 企业、个体户开户银行
        cBankAccountName: "", // 企业、个体户银行账户名称
        cBankCardNumber: "", // 企业、个体户银行账号
        cBankAddress: "", //  企业、个体户开户银行地址
        lBankName: "", // 法人开户银行
        lBankAccountName: "", // 法人银行账户名称
        lBankCardNumber: "", // 法人银行账号
        lBankAddress: "" //  法人开户银行地址
      },
      operatingPeriodDisabled: false, // 是否禁用日期选择
      customerCheckInfo: null, // 审核不通过原因
      rules: {
        businessLicence: [
          { required: true, message: this.$t("certification.rule1"), trigger: "change" }
        ],
        creditCode: [
          {
            required: true,
            message:this.$t("certification.rule2"),
            trigger: "blur"
          }
        ],
        companyName: [
          { required: true, message: this.$t("certification.rule3"), trigger: "blur" }
        ],
        operatingPeriod: [
          // { required: true, message: '请选择经营期限', trigger: 'change' },
          { message: this.$t("certification.rule4"), trigger: "change" },
          {
            validator: (rule, value, callback, source, options) => {
              const isLongOperatingPeriod = this.ruleForm.isLongOperatingPeriod;
              // console.log(value)
              // console.log(isLongOperatingPeriod)
              if (isLongOperatingPeriod) {
                this.operatingPeriodDisabled = true;
                callback();
              } else {
                this.operatingPeriodDisabled = false;
                if (value === "" || !value) {
                  callback(new Error(this.$t("certification.rule4")));
                } else {
                  callback();
                }
              }
              return true;
            }
          }
        ],
        selectedlocal: [
          { required: true, message: this.$t("certification.rule5"), trigger: "change" }
        ],
        detailAddress: [
          { required: true, message: this.$t("certification.rule6"), trigger: "blur" }
        ],
        legalPersonName: [
          { required: true, message:this.$t("certification.rule7"), trigger: "blur" }
        ],
        IDCard1: [
          { required: true, message: this.$t("certification.rule8"), trigger: "change" }
        ],
        IDCard2: [
          { required: true, message:this.$t("certification.rule9"), trigger: "change" }
        ],
        IdentityNumber: [
          { required: true, message: this.$t("certification.rule10"), trigger: "blur" }
        ],
        cBankName: [
          { required: true, message: this.$t("certification.rule11"), trigger: "blur" }
        ],
        cBankAccountName: [
          { required: true, message: this.$t("certification.rule12"), trigger: "blur" }
        ],
        cBankCardNumber: [
          { required: true, message: this.$t("certification.rule13"), trigger: "blur" }
        ],
        cBankAddress: [
          { required: true, message:this.$t("certification.rule14"), trigger: "blur" }
        ],
        lBankName: [
          { required: true, message: this.$t("certification.rule15"), trigger: "blur" }
        ],
        lBankAccountName: [
          { required: true, message: this.$t("certification.rule16"), trigger: "blur" }
        ],
        lBankCardNumber: [
          { required: true, message: this.$t("certification.rule17"), trigger: "blur" }
        ],
        lBankAddress: [
          { required: true, message: this.$t("certification.rule18"), trigger: "blur" }
        ]
      },
      bankLabelWidth: "160px",
      locationOptions: null,
      show: false,
      auth: {}
    };
  },
  computed: {
    ...mapState({
      supplierInfo: state => state.supplier.supplierInfo
    })
  },
  mounted() {
    this.auth = JSON.parse(localStorage.getItem("auth")) || {};
    this.isSupplierData();
  },
  methods: {
    ...mapActions(["getSupplier"]),
    back() {
      var auth = JSON.parse(localStorage.getItem("auth")) || {};
      if (auth.userMode == 2) {
        this.$router.replace("/public");
      } else if (auth.userMode == 1) {
        this.$router.push("/supplier");
      } else {
        if (this.supplierInfo.B2bMode == 1) {
          this.$router.push("/public");
        }
        if (this.supplierInfo.B2b2cMode == 1) {
          this.$router.push("/supplier");
        }
      }
    },
    isSupplierData() {
      // let param = {}
      this.getSupplier()
        .then(res => {
          console.log(res);
          // 有提交认证初始化数据
          res.data.IsSubmit && this.initDta(res.data);
          /// /无提交认证初始化数据
          !res.data.IsSubmit && this.getProvinces();
        })
        .catch(error => {
          console.log(error);
          this.$message.error(error.message);
        });
    },
    // 初始化数据
    initDta(data) {
      // console.log(data)
      let ruleForm = {
        businessLicence: data.BusinessLicence, // 营业执照
        creditCode: data.CreditCode, // 社会信用代码
        companyName: data.CompanyName, // 公司名
        operatingPeriod: data.OperatingPeriod, // 经营期限
        isLongOperatingPeriod: data.IsLongOperatingPeriod === "true", // 是否长期经营
        selectedlocal: [], // 地区选择
        detailAddress: data.DetailAddress, // 详细地址
        legalPersonName: data.LegalPersonName, // 法人名称
        IDCard1: data.LegalPersonIDCard1, // 身份证正面
        IDCard2: data.LegalPersonIDCard2, // 身份证反面
        IdentityNumber: data.IdentityNumber, // 身份证号码
        cBankName: data.CBankName, // 企业、个体户开户银行
        cBankAccountName: data.CBankAccountName, // 企业、个体户银行账户名称
        cBankCardNumber: data.CBankCardNumber, // 企业、个体户银行账号
        cBankAddress: data.CBankAddress, //  企业、个体户开户银行地址
        lBankName: data.LBankName, // 法人开户银行
        lBankAccountName: data.LBankAccountName, // 法人银行账户名称
        lBankCardNumber: data.LBankCardNumber, // 法人银行账号
        lBankAddress: data.LBankAddress //  法人开户银行地址
      };
      this.operatingPeriodDisabled = data.IsLongOperatingPeriod === "true";
      this.ruleForm = ruleForm;
      this.customerCheckInfo = data.CustomerCheckInfo;
      this.CustomerId = data.CustomerId;
      this.$refs.IDCard1Preview.src = this.$api.formatImageUrl(
        data.LegalPersonIDCard1
      );
      this.$refs.IDCard2Preview.src = this.$api.formatImageUrl(
        data.LegalPersonIDCard2
      );
      this.$refs.businessLicencePreview.src = this.$api.formatImageUrl(
        data.BusinessLicence
      );
      let cityList = [];
      // 获取城市列表
      this.$api.system
        .getProvinces()
        .then(res => {
          this.locationOptions = res.data.map(province => {
            let option = {
              value: province.ProvinceId,
              label: province.ProvinceName,
              children: []
            };
            return option;
          });
          cityList.push(data.ProvincesCode);
          cityList.push(data.CitysCode);
          cityList.push(data.AreasCode);
          let intCityList = cityList.map(item => {
            item = JSON.parse(item);
            return item;
          });
          // 赋值给selectedlocal
          this.ruleForm.selectedlocal = intCityList;
          this.cityUi(intCityList);
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    uploadFile(name) {
      this.$refs[name].click();
    },
    fileChanged(e, name) {
      let file = e.target.files[0];
      if (!file) return;
      console.log(file);
      this.$api.system
        .uploadImgFile(file, {}, progressEvent => {
          // console.log(progressEvent)
        })
        .then(res => {
          if (res.code === 200) {
            this.ruleForm[name] = res.data.DefaultUrl;
            let preview = this.$refs[name + "Preview"];
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function(e) {
              preview.src = this.result;
            };
            this.$message({
              type: "success",
              message: "上传成功!"
            });
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    localActiveItemChangHandle(val) {
      // debugger
      if (val.length > 1) {
        let provinceID = val[0];
        let cityID = val[1];
        let province = this.locationOptions.find(element => {
          return element.value === provinceID;
        });
        if (province) {
          let city = province.children.find(element => {
            return element.value === cityID;
          });
          if (city && !city.children.length) {
            this.getAreas(city);
          }
        }
      } else if (val.length > 0) {
        let provinceID = val[0];
        let province = this.locationOptions.find(element => {
          return element.value === provinceID;
        });
        if (province && !province.children.length) {
          this.getCities(province);
        }
      }
    },
    // 渲染城市列表
    cityUi(val) {
      let provinceID = val[0];
      let cityID = val[1];
      let province = this.locationOptions.find(element => {
        return element.value === provinceID;
      });
      if (province && !province.children.length) {
        new Promise(resolve => {
          // 获取市
          this.$api.system.getCities(province.value).then(res => {
            province.children = res.data.map(city => {
              return {
                value: city.CityId,
                label: city.CityName,
                children: []
              };
            });
            resolve(province);
          });
        })
          .then(res => {
            let city = province.children.find(element => {
              return element.value === cityID;
            });
            new Promise(resolve => {
              // 获取区域
              this.getAreas(city);
              resolve(city);
            }).then(res => {
              console.log(res);
            });
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    localChangeHandle(val) {
      console.log("localChangeHandle", val);
    },
    // 关掉弹框
    submitHandle() {
      this.$refs.ruleForm.validate((valid, obj) => {
        if (valid) {
          this.submit();
        } else {
          let keys = Object.keys(obj);
          let msg = obj[keys[0]][0].message;
          this.$message.error(msg);
        }
      });
    },
    closeAction() {
      if (this.show === true) {
        this.back();
      } else {
      }
    },
    getProvinces() {
      this.$api.system
        .getProvinces()
        .then(res => {
          this.locationOptions = res.data.map(province => {
            let option = {
              value: province.ProvinceId,
              label: province.ProvinceName,
              children: []
            };
            return option;
          });
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    getCities(province) {
      this.$api.system.getCities(province.value).then(res => {
        province.children = res.data.map(city => {
          return {
            value: city.CityId,
            label: city.CityName,
            children: []
          };
        });
      });
    },
    getAreas(city) {
      this.$api.system.getAreas(city.value).then(res => {
        city.children = res.data.map(element => {
          return {
            value: element.AreaId,
            label: element.AreaName
          };
        });
      });
    },
    submit() {
      // this.Theformsubmission.push(this.ruleForm)
      let isLongOperatingPeriod = false; // 是否长期经营
      this.ruleForm.isLongOperatingPeriod && (isLongOperatingPeriod = true);
      let param = {
        BusinessLicence: this.ruleForm.businessLicence,
        CreditCode: this.ruleForm.creditCode,
        CompanyName: this.ruleForm.companyName,
        DetailAddress: this.ruleForm.detailAddress,
        LegalPersonName: this.ruleForm.legalPersonName,
        LegalPersonIDCard1: this.ruleForm.IDCard1,
        LegalPersonIDCard2: this.ruleForm.IDCard2,
        IdentityNumber: this.ruleForm.IdentityNumber, // 身份证号码
        CBankName: this.ruleForm.cBankName,
        CBankAccountName: this.ruleForm.cBankAccountName,
        CBankCardNumber: this.ruleForm.cBankCardNumber,
        CBankAddress: this.ruleForm.cBankAddress,
        LBankName: this.ruleForm.lBankName,
        LBankAccountName: this.ruleForm.lBankAccountName,
        LBankCardNumber: this.ruleForm.lBankCardNumber,
        LBankAddress: this.ruleForm.lBankAddress,
        OperatingPeriod: this.ruleForm.operatingPeriod,
        isLongOperatingPeriod: isLongOperatingPeriod,
        FirstSelectionMode: this.auth.userMode
      };
      // 如果是编辑添加CustomerId
      this.CustomerId && (param.CustomerId = this.CustomerId);
      param.ProvincesCode = this.ruleForm.selectedlocal[0];
      param.CitysCode = this.ruleForm.selectedlocal[1];
      param.AreasCode = this.ruleForm.selectedlocal[2];
      param.Type = this.type === "business" ? this.$t("certification.type1") : this.$t("certification.type2");
      this.$api.login
        .registerCustomerCheckInfo(param)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: this.$t("certification.submitSuccess")
            });
            this.show = true;
          } else {
            this.$message({
              type: "error",
              message: this.$t("certification.submitFail")
            });
          }
        })
        .catch(() => {});
    },
    ...mapMutations([SET_AUTH])
  }
};
</script>

<style lang="scss" scoped>
.back-button {
  left: 3%;
  top: 1.5%;
  font-size: 14px;
  position: absolute;
  z-index: 11;
}
.submit-btn {
  z-index: 100;
  position: relative;
  width: 450px;
  display: block;
  margin: 5% auto 10%;
}
.content-box {
  margin-left: 5%;
  margin-right: 5%;
  .shuoming {
    margin-left: 12%;
    color: #9d9d9d;
    .label {
      color: #606266;
      font-weight: bold;
      font-size: 16px;
    }
  }
}
.license,
.Id_card .card_content {
  display: flex;
  text-align: center;
  justify-content: center;
  p {
    color: #fff;
    border-radius: 50px;
    width: 100px;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    cursor: pointer;
  }
  img {
    display: block;
    width: 260px;
    height: 320px;
    object-fit: contain !important;
  }
  .case {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 148px;
    > p {
      color: #000;
    }
  }
  .upload {
    display: flex;
    flex-direction: column;
    align-items: center;
    > p {
      background: #22b196;
    }
  }
}
.goback {
  position: absolute;
  top: 60px;
  left: 153px;
  color: #333;
  font-weight: 600;
  display: flex;
  ::before {
    // content: "<";
    display: block;
    text-align: center;
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
}
.registerMessage {
  padding: 0 20% 0 0;
}
.Id_card {
  padding: 0 10%;
  text-align: center;
  .card_title {
    display: flex;
    align-items: center;
    line-height: 20px;
    > p {
      font-size: 20px;
      color: #f56c6c;
      margin-right: 1%;
    }
  }
  .card_content {
    img {
      width: 260px;
      height: 150px;
    }
  }
  .card_content_text {
    margin-top: 5%;
    display: flex;
    justify-items: center;
    align-items: center;

    &::before,
    &::after {
      display: block;
      height: 1px;
      background-color: #dcdedc;
      flex-grow: 1;
      content: "";
    }
    .ratepaying {
      color: #ff5852;
      background: #fff;
      font-weight: bold;
      padding: 1% 1%;
    }
  }
}
.enterprise_bank {
  margin-top: 78px;
  padding: 0 15%;
  .enterprise_bank_title {
    color: #22b196;
    margin-right: 1%;
    display: flex;
    justify-content: center;
    align-items: center;
    &::after {
      content: "";
      display: block;
      border-top: 1px dashed #22b196;
      margin-left: 1%;
      height: 1px;
      flex-grow: 1;
    }
  }
  .enterprise_bank_content {
    margin-top: 6%;
    margin-left: auto;
    margin-right: auto;
    // border-top: 1px dashed #22b196;
    width: 640px;
  }
}
.msg-error {
  color: #f56c6c;
  text-align: center;
}
.dialog {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;

  .content {
    width: 706px;
    height: 396px;
    background-color: white;
    border-radius: 20px;
    background-image: url("../../assets/img/img_popup_1.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: 0 0;
    position: relative;

    .close {
      width: 24px;
      height: 24px;
      position: absolute;
      right: 34px;
      top: 24px;
      cursor: pointer;
      z-index: 11;
    }

    .text {
      display: block;
      margin: 176px auto 0;
    }
  }
}
.errorBox {
  margin: 0 auto;
  width: 100%;
  text-align: center;
  padding-top: 15px;
  .errorBoxTitle {
    //  color: #333;
    color: red;
    font-weight: 600;
    margin: 10px auto;
  }
}
</style>
